import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Helper function to categorize backlinks
const categorizeBacklinks = (backlinks) => {
  const numBacklinks = parseInt(backlinks, 10);
  if (numBacklinks <= 5) return '1-5';
  if (numBacklinks <= 10) return '6-10';
  if (numBacklinks <= 20) return '11-20';
  return '21+';
};

// Component to display Top Linking Domains Histogram
const TopLinkingDomainsChart = ({ data }) => {
  // Bin the data into ranges
  const histogramData = data.reduce((acc, item) => {
    const category = categorizeBacklinks(item.backlinks);
    
    // Initialize the bin if it does not exist
    if (!acc[category]) {
      acc[category] = { range: category, count: 0, domains: [] };
    }

    // Increment the count and add the domain
    acc[category].count += 1;
    acc[category].domains.push(item.domain.url);

    return acc;
  }, {});

  // Convert histogramData to chartData
  const chartData = Object.values(histogramData);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="range"
          tick={{ angle: -45, textAnchor: 'end' }}
          interval={0}
        />
        <YAxis label={{ value: "Count", angle: -90, position: "insideLeft" }} />
        <Tooltip />
        <Bar
          dataKey="count"
          fill="rgb(255, 77, 112)"
        />
        <text
          x={200}
          y={370}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          Domains Listed Below Bars
        </text>
      </BarChart>
      <div style={{ marginTop: 20 }}>
        {chartData.map((entry, index) => (
          <div key={index} style={{ marginBottom: '10px' }}>
            <strong>{entry.range} Backlinks:</strong>
            <ul>
              {entry.domains.map((domain, i) => (
                <li key={i}>
                  <a href={domain} target="_blank" rel="noopener noreferrer">{domain}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </ResponsiveContainer>
  );
};

export default TopLinkingDomainsChart;
